{
  "title": "Version des composants",
  "technicalVersion": "Version technique :",
  "components": {
    "alertManager": "Administrador de alertas",
    "deviceTwinManagerEsoft": "Administrador de equipo doble (eSoftLink)",
    "campaignManager": "Administrador de campañas",
    "pkiConnector": "Conector PKI",
    "userManager": "Administrador de usuarios",
    "applicationManager": "Administrador de aplicaciones",
    "contentManager": "Administrador de contenidos",
    "caCertificateManager": "Administrador de autoridad de certificados",
    "certificateManager": "Administrador de certificados",
    "apiGateway": "Gateway de API",
    "translationManager": "Gerente de traducción",
    "operationManager": "Gerente de operaciones",
    "deviceTwinManager": "Administrador de equipo doble",
    "licenseManager": "Administrador de licencias",
    "dataManager": "Administrador de datos",
    "as": "Servicio de aplicación Front-end",
    "fi": "Interfaz Front-end",
    "lwm2mConnector": "Conector LwM2M",
    "dataEnrichment": "Enriquecimiento de datos"
  },
  "tile": {
    "version": "Versión",
    "noData": "La version de ce composant n'a pas pu être récupérée.",
    "component": "Composant"
  }
}
